<template>
    <div class="login-container">
        <div class="login-box">
            <p class="login-title">登录</p>
            <input
                class="input accout"
                maxlength="18"
                placeholder="手机号/身份证"
                autocomplete="on"
                type="text"
                v-model="username"
                @focus="removeErrtag(0)"
            />
            <div v-show="errorData[0].errorTag" class="error-msg">
                {{ errorData[0].errorText }}
            </div>
            <input
                class="input pwd"
                v-model="password"
                placeholder="密码"
                @focus="removeErrtag(1)"
                type="password"
            />
            <div v-show="errorData[1].errorTag" class="error-msg">
                {{ errorData[1].errorText }}
            </div>
            <div class="input code">
                <input
                    class="input code-text"
                    placeholder="验证码"
                    v-model="code"
                    type="text"
                />
                <div class="code-img">
                    <canvas @click="changeCode()" class="randomCode"></canvas>
                </div>
            </div>
            <div v-show="errorData[2].errorTag" class="error-msg">
                {{ errorData[2].errorText }}
            </div>
            <div class="input clearfix login-type-box">
                <label class="auto-box" for="autologin">
                    <input
                        type="checkbox"
                        name="autologin"
                        id="autologin"
                        v-model="autoLogin"
                    />自动登录
                </label>
                <span class="forget-span" @click="goForget">忘记密码</span>
            </div>
            <input
                @click="submitLogin"
                type="button"
                class="login-btn"
                value="登录"
            />
        </div>
        <transition
            enter-active-class="fadeInDown"
            leave-active-class="fadeOutUp"
        >
            <eazy-toast v-show="errtipsFlag">
                <h2 slot="title" class="eazy-toast-title">错误信息:</h2>
                <div class="eazy-toast-detail">{{ errtips }}</div>
            </eazy-toast>
        </transition>
    </div>
</template>

<script>
import eazyToast from "@/components/common/eazytoast";
import { mapState, mapMutations } from "vuex";
import { setCookie } from "@/common/util";
import { encrypt } from "@/common/aes";
import md5 from "js-md5";

export default {
    data() {
        return {
            autoLogin: false,
            username: "",
            password: "",
            code: "",
            errtipsFlag: false,
            errtips: "",
            errorData: [
                { errorTag: false, errorText: "" },
                { errorTag: false, errorText: "" },
                { errorTag: false, errorText: "" }
            ],
            cancommit: true,
            timmerOut: null,
            randomCodeStr: ""
        };
    },
    components: {
        eazyToast
    },
    mounted() {
        this.randomCodeStr = this.drawPic(".randomCode");
    },
    methods: {
        ...mapMutations(["login"]),
        goForget() {
            this.$router.push({
                name: "forget"
            });
        },
        myBrowser() {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isOpera = userAgent.indexOf("Opera") > -1;
            var isIE11 =
                userAgent.indexOf("Trident") > -1 &&
                userAgent.indexOf("rv:11.0") > -1;

            if (isOpera) {
                return 5;
            } //判断是否Opera浏览器
            if (userAgent.indexOf("Firefox") > -1) {
                return 3;
            } //判断是否Firefox浏览器
            if (userAgent.indexOf("Chrome") > -1) {
                return 2;
            }
            if (userAgent.indexOf("Safari") > -1) {
                return 4;
            } //判断是否Safari浏览器
            if (
                userAgent.indexOf("compatible") > -1 &&
                userAgent.indexOf("MSIE") > -1 &&
                !isOpera
            ) {
                return 1;
            } //判断是否IE浏览器
            if (isIE11) {
                return 1;
            }
            return 5;
        },
        changeCode() {
            this.randomCodeStr = this.drawPic(".randomCode");
        },
        drawPic(id) {
            function randomColor(min, max) {
                var _r = randomNum(min, max);
                var _g = randomNum(min, max);
                var _b = randomNum(min, max);
                return "rgb(" + _r + "," + _g + "," + _b + ")";
            }
            function randomNum(min, max) {
                return Math.floor(Math.random() * (max - min) + min);
            }
            //获取到元素canvas
            var $canvas = document.querySelector(id);
            var _str =
                "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"; //设置随机数库
            var _picTxt = ""; //随机数
            var _num = 4; //4个随机数字
            var _width = $canvas.width;
            var _height = $canvas.height;
            var ctx = $canvas.getContext("2d"); //获取 context 对象
            ctx.textBaseline = "bottom"; //文字上下对齐方式--底部对齐
            ctx.fillStyle = randomColor(150, 240); //填充画布颜色
            ctx.fillRect(0, 0, _width, _height); //填充矩形--画画
            for (var i = 0; i < _num; i++) {
                var x = ((_width - 50) / _num) * i + 40;
                var y = randomNum(_height / 2, _height);
                var deg = randomNum(-45, 45);
                var txt = _str[randomNum(0, _str.length)];
                _picTxt += txt; //获取一个随机数
                ctx.fillStyle = randomColor(10, 100); //填充随机颜色
                ctx.font = randomNum(65, 75) + "px Arial"; //设置随机数大小，字体为SimHei
                ctx.translate(x, y); //将当前xy坐标作为原始坐标
                ctx.rotate((deg * Math.PI) / 180); //旋转随机角度
                ctx.fillText(txt, 0, 0); //绘制填色的文本
                ctx.rotate((-deg * Math.PI) / 180);
                ctx.translate(-x, -y);
            }
            for (var i = 0; i < _num; i++) {
                //定义笔触颜色
                ctx.strokeStyle = randomColor(90, 180);
                ctx.beginPath();
                //随机划线--4条路径
                ctx.moveTo(randomNum(0, _width), randomNum(0, _height));
                ctx.lineTo(randomNum(0, _width), randomNum(0, _height));
                ctx.stroke();
            }
            for (var i = 0; i < _num * 10; i++) {
                ctx.fillStyle = randomColor(0, 255);
                ctx.beginPath();
                //随机画原，填充颜色
                ctx.arc(
                    randomNum(0, _width),
                    randomNum(0, _height),
                    1,
                    0,
                    2 * Math.PI
                );
                ctx.fill();
            }
            return _picTxt; //返回随机数字符串
        },
        submitLogin() {
            this.cancommit = true;
            // if (this.username.length < 11) {
            //     this.errorData[0].errorTag = true;
            //     this.errorData[0].errorText = "手机号或身份证错误";
            //     this.cancommit = false;
            // }
            if (this.password.length < 6 || this.password.length > 19) {
                this.errorData[1].errorTag = true;
                this.errorData[1].errorText = "密码长度错误";
                this.cancommit = false;
            }
            if (this.code.toUpperCase() != this.randomCodeStr.toUpperCase()) {
                this.errorData[2].errorTag = true;
                this.errorData[2].errorText = "验证码错误";
                this.changeCode();
                this.cancommit = false;
            }

            // 验证码等待对接
            if (this.cancommit) {
                this.$ajax({
                    method: "post",
                    url: "userApi/userLogin",
                    data: {
                        username: encrypt(this.username),
                        password: encrypt(md5(this.password)),
                        countBrowser: this.myBrowser()
                    },
                    success: res => {
                        if (res.code == 200) {
                            if (!this.autoLogin) {
                                setCookie("notAutoLogin", true);
                            }
                            this.login({
                                userName: res.userName,
                                userAvatar: res.userAvatar,
                                userToken: res.userToken,
                                userSelfId: res.userSelfId,
                                autoLogin: this.autoLogin,
                                hasLogin: true // 是否登录
                            });
                            this.$router.push({ path: "/shouye" });
                        } else {
                            this.errtips = res.massge;
                            console.log(res.massge)
                            this.errtipsFlag = true;

                            if (this.timmerOut) {
                                clearTimeout(this.timmerOut);
                                this.timmerOut = null;
                            }
                            this.timmerOut = setTimeout(() => {
                                this.errtipsFlag = false;
                                clearTimeout(this.timmerOut);
                                this.timmerOut = null;
                            }, 2000);

                            this.changeCode();
                        }
                    },
                    error: res => {
                        console.log(res);
                    }
                });
            }
        },
        removeErrtag(index) {
            this.errorData[index].errorTag = false;
        }
    },
    computed: {
        ...mapState(["hasLogin", "userToken"])
    }
};
</script>

<style lang="scss" scoped>
.error-msg {
    color: red;
    width: 254px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    text-align: left;
    margin: 0 auto;
}

.login-container {
    width: 1000px;
    margin: 0 auto;
    font-size: 16px;
    color: #000;
}

.iconfont {
    font-size: 50px;
    color: red;
}

.login-box {
    width: 353px;
    background-color: #ffffff;
    box-shadow: 0px 2px 10px 0px rgba(92, 93, 93, 0.33);
    margin: 0 auto;
    margin-top: 100px;
    margin-bottom: 200px;
    text-align: center;
    overflow: hidden;
    padding-bottom: 30px;
}

.login-title {
    margin-top: 30px;
    margin-left: 50px;
    font-size: 16px;
    color: #000 !important;
    text-align: left;
}

.input {
    width: 254px;
    height: 34px;
    background-color: #ffffff;
    border: solid 1px #84b0f6;
    margin: 0 auto;
    font-size: 14px;
    text-align: left;
    margin-top: 8px;
    text-indent: 10px;
}

.accout {
    margin-top: 10px;
}

.code {
    border: none;
    height: auto;
    text-indent: 0;
}

.code-text {
    width: 145px;
    margin: 0;
    display: inline-block;
    vertical-align: middle;
}

.code-img {
    width: 100px;
    height: 34px;
    border: solid 1px #bbb;
    display: inline-block;
    vertical-align: middle;
}
.randomCode {
    width: 100px;
    height: 34px;
}

.login-type-box {
    border: 0;
    text-align: left;
    line-height: 34px;
}

#autologin {
    display: inline-block;
}

.auto-box {
    width: 100px;
    height: 34px;
    margin: 0 auto;
    text-align: left;
    vertical-align: middle;
}

.login-type-box span {
    float: right;
}

.login-btn {
    width: 254px;
    height: 34px;
    background-color: #009cff;
    border-radius: 4px;
    border: 0;
}
.login-btn:hover {
    background-color: #559cff;
}
// 消息标题
.eazy-toast-title {
    padding: 10px 0;
    font-size: 18px;
    font-weight: bold;
    color: red;
}
.eazy-toast-detail {
    color: #000;
}
.forget-span {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue